// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog-color {
  display: flex;
  flex-direction: column;
  width: 680px;
  height: 560px;
  max-height: 80vh;
  min-height: 300px;
}
.dialog-color_palette-mode {
  height: 560px;
}
.dialog-color_gradient-mode {
  height: 380px;
}
.dialog-color_gradient-mode .color-settings-container__row {
  border-bottom: none;
}
.dialog-color_gradient-mode .color-settings-container__label {
  margin: 0 20px 0 0;
}
.dialog-color .g-dialog-header {
  padding-bottom: 15px;
}
.dialog-color_palette-mode .g-dialog-body {
  height: 80vh;
  padding: 0;
  overflow-y: auto;
}
.dialog-color_palette-mode .g-dialog-footer {
  border-top: 1px solid var(--g-color-line-generic);
}
.dialog-color__title-icon {
  margin-bottom: 2px;
  margin-right: 4px;
  height: 24px;
  width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/ui/units/wizard/components/Dialogs/DialogColor/DialogColor.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;AACJ;AACI;EACI,aAAA;AACR;AAEI;EACI,aAAA;AAAR;AAGY;EACI,mBAAA;AADhB;AAIY;EACI,kBAAA;AAFhB;AAOI;EACI,oBAAA;AALR;AAQI;EACI,YAAA;EACA,UAAA;EACA,gBAAA;AANR;AASI;EACI,iDAAA;AAPR;AAUI;EACI,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AARR","sourcesContent":[".dialog-color {\n  display: flex;\n  flex-direction: column;\n  width: 680px;\n  height: 560px;\n  max-height: 80vh;\n  min-height: 300px;\n}\n.dialog-color_palette-mode {\n  height: 560px;\n}\n.dialog-color_gradient-mode {\n  height: 380px;\n}\n.dialog-color_gradient-mode .color-settings-container__row {\n  border-bottom: none;\n}\n.dialog-color_gradient-mode .color-settings-container__label {\n  margin: 0 20px 0 0;\n}\n.dialog-color .g-dialog-header {\n  padding-bottom: 15px;\n}\n.dialog-color_palette-mode .g-dialog-body {\n  height: 80vh;\n  padding: 0;\n  overflow-y: auto;\n}\n.dialog-color_palette-mode .g-dialog-footer {\n  border-top: 1px solid var(--g-color-line-generic);\n}\n.dialog-color__title-icon {\n  margin-bottom: 2px;\n  margin-right: 4px;\n  height: 24px;\n  width: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
